module.exports = __webpack_public_path__ + "static/discord-aa4132ab69fab698a73d5a3e15b7f36c.png";